module.exports = __webpack_public_path__ + "img/warning.4bddade9.svg";